import list from './list';
import { default as icon } from '@mui/icons-material/Event';
import {
	Create,
	DeleteButton,
	Edit,
	SaveButton,
	SimpleForm,
	Toolbar,
	useRecordContext
} from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { FormFields, SessionFormFields, StatusToggleInput } from './components';

const create = () => (
	<Create>{FormFields}</Create>
);

const SessionHeader = () => {
	const record = useRecordContext();

	if ( !record ) {
		return null;
	}

	return (
		<div>
			<Typography variant="body2">
				<Link to="/sessions">Sessions</Link>
				{' / '}
				Edit
			</Typography>
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
				<Typography variant="h5" component="h1">
					{record.name || `Session ${record.id}`}
				</Typography>
				<StatusToggleInput />
			</Box>
		</div>
	);
};

const CancelSessionButton = () => {
	const { reset, formState } = useFormContext();

	return (
		<Button
			variant="outlined"
			onClick={() => reset()}
			disabled={!formState.isDirty}
			sx={{ ml: 1 }}
		>
			Cancel
		</Button>
	);
};

const SessionToolbar = () => (
	<Toolbar sx={{ gap: 1 }}>
		<SaveButton />
		<CancelSessionButton />
		<DeleteButton variant="outlined" />
	</Toolbar>
);

const edit = () => (
	<Edit redirect="edit">
		<SimpleForm warnWhenUnsavedChanges toolbar={<SessionToolbar />}>
			<SessionHeader />
			{SessionFormFields}
		</SimpleForm>
	</Edit>
);

export const Session = {
	list,
	edit,
	create,
	icon
};

export default Session;
